import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import background3 from '../assets/background3.png';

class TestRecords extends Component {
  render() {
    const pageStyle = {
      backgroundImage: `linear-gradient(rgba(255,255,255,0.7), rgba(255,255,255,0.7)), url(${background3})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '100vh',
    };

    const contentStyle = {
      maxWidth: 900,
      margin: '0 auto',
      padding: '32px 16px 48px',
      textAlign: 'center',
      color: '#111',
      lineHeight: 1.6,
    };

    return (
      <div className="App" style={pageStyle}>
        <div style={contentStyle}>
          <div style={{ textAlign: 'left' }}>
            <img className="logo" src={logo} alt="Thai-Aikikai logo" />
          </div>

          <br />
          <div>Thailand&apos;s Aikido Association Registration and Class Attending System...</div>
          <br />
          <div><Link to="/testresults270926">Test Results 27/09/26</Link></div>
          <br />
          <div><Link to="/testresults200926">Test Results 20/09/26</Link></div>
          <br />
          <div><Link to="/testresults210626">Test Results 21/06/26</Link></div>
          <br />
          <div><Link to="/testresults140626">Test Results 14/06/26</Link></div>
          <br />
          <div><Link to="/testresults220326">Test Results 22/03/26</Link></div>
          <br />
          <div><Link to="/testresults150326">Test Results 15/03/26</Link></div>
          <br />
          <div><Link to="/testresults211225">Test Results 21/12/25</Link></div>
          <br />
          <div><Link to="/testresults071225">Test Results 07/12/25</Link></div>
          <br />
          <div><Link to="/testresults140925">Test Results 14/09/25</Link></div>
          <br />
          <div><Link to="/testresults070925">Test Results 07/09/25</Link></div>
          <br />
          <div><Link to="/testresults220625">Test Results 22/06/25</Link></div>
          <br />
          <div><Link to="/testresults140625">Test Results 14/06/25</Link></div>
          <br />
          <div><Link to="/testresults230325">Test Results 23/03/25</Link></div>
          <br />
          <div><Link to="/testresults080325">Test Results 08/03/25</Link></div>
          <br />

          <div>Powered by</div>
          <img
            className="logo2"
            src={logo2}
            alt="New Wave Consulting Group"
            style={{ height: 50 }}
          />
          <div>New Wave Consulting Group</div>
        </div>
      </div>
    );
  }
}

export default TestRecords;
